export default __webpack_public_path__ + "static/media/islamabad.928140e3.png";